import reducers from '../reducers';
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { historyMiddleware } from '../Middlewares/History.middleware';
import { createStore } from '../store';

global.ReduxServer = {
  createStore: (preloadState) => {
    global.LitiumReduxStore = createStore(preloadState);
  },
};
